import { options } from "less"

const DetailForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    showSlot:true,
    formData:{},
    formField:[
        {
            // name:'order.orderNumber',
            key:'order_name',
            type:'input',
            width:'160px',
            allowClear:true,
            placeholder:'order.orderNumber',
        },
        {
            // name:'order.shipmentNotificationNumber',
            key:'invoice_child_type',
            type:'input',
            width:'210px',
            allowClear:true,
            placeholder:'order.shipmentNotificationNumber',
        },
        {
            // name:'order.invoiceNumber',
            key:'invoice_no',
            type:'input',
            width:'140px',
            allowClear:true,
            placeholder:'order.invoiceNumber',
        },
        {
            // name:'order.invoiceDate',
            key:'invoice_date',
            type:'dateRange',
            width:'240px',
            allowClear:true,
            placeholder:'order.invoiceDate',
        },
        {
            // name:'order.payStatus',
            key:'pay_status',
            type:'select',
            width:'160px',
            allowClear:true,
            placeholder:'order.payStatus',
            optionToLocale:true,
            options:[
                {
                    value:7,
                    label:'order.obligation'
                },
                {
                    value:0,
                    label:'order.partialPay'
                },
                // {
                //     value:1,
                //     label:'order.pay'
                // },
                // {
                //     value:2,
                //     label:'order.refund'
                // },
                // {
                //     value:3,
                //     label:'order.returnsAndRefund'
                // },
                // {
                //     value:4,
                //     label:'order.partialRefund'
                // },
                // {
                //     value:5,
                //     label:'order.partialReturnsAndRefund'
                // },
                // {
                //     value:-1,
                //     label:'order.finalPayment'
                // },
                // {
                //     value:6,
                //     label:'order.canceled'
                // },
            ]
        },
    ]
}

const DetailForm2 = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    showSlot:true,
    formData:{},
    formField:[
        {
            key:'sku',
            type:'select',
            width:'210px',
            allowClear:true,
            placeholder:'order.sku',
            optionToLocale:true,
            options:[]
        },
        {
            key:'inventory_code',
            type:'input',
            width:'210px',
            allowClear:true,
            placeholder:'order.inventoryCode',
        },
    ]
}


DetailForm.formField.forEach(item=>{
    DetailForm.formData[item.key] = ''
})

DetailForm2.formField.forEach(item=>{
    DetailForm2.formData[item.key] = ''
})

export {
    DetailForm,
    DetailForm2,
}